import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import "./Navbar.css";
import Logo from "../Assets/BUE-Logo.png";
import Person from "../Assets/person.png";
import Logout from "../Login/Logout";
//import SimpleModal from "../User/SimpleModal";
import { Link, useHistory } from "react-router-dom";
import UserProfile from "../User/UserProfile";
import jwt from "jwt-decode";
import axios from "axios";
import config3 from "../Util/config";
import Button from "react-bootstrap/Button";
import NavDropdown from "react-bootstrap/NavDropdown";
const Menu = () => {
  const history = useHistory();
  const [userData, setUserData] = useState({
    userId: 0,
    username: "",
    email: "",
    password: "",
    roleId: 0,
    roleName: "",
  });

  const GetUserProfile = () => {
    const userToken = localStorage.getItem("accessToken");
    const userId = jwt(userToken).nameid;
    var data = "";
    var config = {
      method: "get",
      url: `${config3.BASE_URL}/api/Users/GetUserbyUserID?userId=${userId}`,
      headers: {
        // Authorization: `Bearer ${getToken()}`
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //console.log("User Profile API", JSON.stringify(response.data));
        setUserData(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  React.useEffect(() => {
    GetUserProfile();
  }, []);
  return (
    <div className="HeaderStiky">
      <Router>
        <Navbar bg="light" expand="lg" sticky="top">
          <Navbar.Brand
            style={{ color: "black", cursor: "pointer" }}
            onClick={() => history.push("/dashboard")}
          >
            <img
              src={Logo}
              alt="logo"
              width="110px"
              height="600px"
              className="img-fluid"
              style={{ marginTop: 5 }}
            />
            {/* <AnalogClock {...options}  style={{float:"right"}}/> */}
          </Navbar.Brand>

          {/* <NavDropdown title="Whistleblowing Policy" id="basic-nav-dropdown">
            <NavDropdown.Item href="https://www.youtube.com/watch?v=67o-jrEFQg4&ab_channel=TheBritishUniversityinEgypt">
              English video version
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.youtube.com/watch?v=G_oaf_wO_sE&ab_channel=TheBritishUniversityinEgypt">
              Arabic video version
            </NavDropdown.Item>
            <NavDropdown.Divider />
          </NavDropdown> */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              {/*   <Nav.Link href="/"><b>Home</b></Nav.Link> */}
              {/* <Nav.Link href="/AssignApp"><b>Add Student</b></Nav.Link>
              <Nav.Link href="/StudentList"><b>Student-List</b></Nav.Link>
              <Nav.Link href="/StudentListAdmin"><b>Reviews</b></Nav.Link> */}
            </Nav>
            <Navbar.Brand style={{ backgroundColor: "white" }}></Navbar.Brand>
            {/* <UserProfile  UserData={userData} /> */}
            <Button
              variant="outline-danger"
              href="https://www.youtube.com/watch?v=67o-jrEFQg4&ab_channel=TheBritishUniversityinEgypt"
              target="_blank"
            >
              WHISTLEBLOWING POLICY VIDEO (ENGLISH)
            </Button>
            <Button
              variant="outline-danger"
              href="https://www.youtube.com/watch?v=G_oaf_wO_sE&ab_channel=TheBritishUniversityinEgypt"
              target="_blank"
            >
              ڤيديو سياسة الإبلاغ عن المخالفات (عربى)
            </Button>
            <Logout />
          </Navbar.Collapse>
        </Navbar>
      </Router>
    </div>
  );
};

export default Menu;
